import React, { useState, useCallback, useEffect, useRef, memo } from 'react';
import {
    Input, Button, notification, Row, Col,
    Select, Modal, Spin, Form, Radio, Switch,
    Typography,
    Divider
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { DatePicker, MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import ptLocale from "date-fns/locale/pt-BR";
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { format, addDays } from 'date-fns'
import axios from 'axios';
import {
    urlPoder,
    urlBuscaCidadesSimples,
    urlBuscaCidades,
    urlCargo,
    urlUserContratoAutomatico,
    urlBuscaUserByCelular,
    urlCidadesContrato,
    urlContratoSimplesAtivos,
    urlUsersAutomaticoAtendimento,
    urlContratosPlano
} from './../../../../services/request/urls';

import { getToken } from './../../../../services/token';
import { mask, apenasDigitosCelular, CELULAR_DIGITOS_BR } from '../../../../utils/MascaraDeCampos';

import {
    modalAddModuloInputs,
} from './GridStyle';
import {
    convertDataBrParaUS, convertDataEHoraBrParaUS
} from './../../../../services/Conversores';

import {
    removeAcento
} from './../../../../utils/RemoveAcentos';
import { useSelector } from 'react-redux';
import { stateGlobal } from '../../../../interfaces/Global';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const { Text } = Typography;

interface interfDadosDoContrato {
    id: number;
    uuid: string;
    nome: string;
    status: boolean;
    envio_proposta: string;
    vigencia: string | number | null | Date | boolean | any;
    valor_contratado: string;
    cadastro_processos: string;
    observacao: string;
    created_at: string;
    updated_at: string;
    validade_teste?: string | null;
    modalidade: {
        id: number;
        nome: string;
    },
    esfera: {
        id: number;
        nome: string;
    },
    plano?: {
        id: number;
        uuid: string;
        nome: string;
    } | null,
    poder: {
        id: number;
        nome: string;
    },
    situacao_contrato: {
        id: number;
        nome: string;
    },
    tipo_contrato: {
        id: number;
        nome: string;
    },
    controladorContrato: [
        {
            id: number | null;
            contratoId: number | null;
            cidadeId: number | null;
            estadoId: number | null;
            usuarioId: number | null;
            permissaoNotificacaoId: number | null;
        }
    ]
}

interface DadosCidadesAll {
    "id": number,
    "estadoId": number,
    "uuid": string,
    "nome": string,
    "uf": string
}

interface interfaceConfigs {
    nome: string,
    id: number
}

interface interfaceNewConfigs {
    id: number
    uuid: number
    nome: string,
}

interface IContratoLsStorage {
    id: number;
    nome: string;
    plano: {
        id: number;
        nome: string;
    };
    poder: {
        id: number;
        nome: string;
    };
}
interface intfaDadosCidadesDoContrato {
    estadoId: number,
    estadoNome: string,
    estadoSigla: string,
    ibge_id_antigo: number | null,
    id: number,
    latitude: string | null,
    longitude: string | null,
    microrregiaoId: number | null,
    nome: string | null,
    populacao: number | null,
    uf: string | null,
    uuid: string,
    usuarios: string,
}

interface PropsModal {
    visible: boolean;
    setFecharModal: () => void;
    listagemPorContrato?: boolean;
}

const ModalUsuarioRapido: React.FC<PropsModal> = memo(({ visible, setFecharModal, listagemPorContrato = false }) => {

    // const formRef = useRef<any>(null);
    // formRef = React.createRef();
    const propsState = useSelector((state: stateGlobal) => state.global);

    const refApertouSelectContrato = useRef<number>(0);
    const refApertouSelectCidade = useRef<number>(0);

    const refAllDadosContrato = useRef<Array<interfDadosDoContrato>>([]);

    const queryParans = useQuery();

    //para poder cancelar a requisição
    const signal = axios.CancelToken.source();
    const signal1 = axios.CancelToken.source();

    const [selectedDate, handleDateChange] = useState<any>(null);
    const [selectedDateVincularUserRapido, setSelectedDateVincularUserRapido] = useState<any>(null);

    const [loadingSelCity, setLoadingSelCity] = useState(false);

    const refClickSubmitSalvar = React.useRef<boolean>(false);
    //user rapido states
    const refFormModalUserRapido = React.useRef<any>(null);
    const inputNomeCompletoUserRapido = React.useRef<any>(null);
    const refIdPoderModalUserRapido = React.useRef<any>(null);
    const refNomeCidadeModalUserRapido = React.useRef<any>(null);

    const valorLsStorageContratoSelecionado = React.useRef<null | IContratoLsStorage>(null);

    const [loadingFormAddUserRapido, setLoadingFormAddUserRapido] = useState(false);
    const [modalAddUserRapido, setModalAddUserRapido] = useState(false);

    const [loadingPlanoSelected, setLoadingPlanoSelected] = useState(false);
    const [dadosPlanoList, setDadosPlanoList] = useState<Array<interfaceNewConfigs>>([]);
    const refDadosPlanoList = useRef<Array<interfaceNewConfigs>>([]);

    const [loadingPoderSelected, setLoadingPoderSelected] = useState(false);
    const [dadosPoderList, setDadosPoderList] = useState<Array<interfaceConfigs>>([]);
    const refDadosPoderList = React.useRef<Array<interfaceConfigs>>([]);

    const [isSelectCidadeOpen, setIsSelectCidadeOpen] = useState(false);
    const [dadosCidadesList, setDadosCidadesList] = useState<Array<DadosCidadesAll>>([]);

    const [dadosDoCargoList, setDadosDoCargoList] = useState<Array<interfaceConfigs>>([]);
    const refDadosCargoList = React.useRef<Array<interfaceConfigs>>([]);

    const [isVisibleDateProximoContato, setIsVisibleDateProximoContato] = useState(true);

    const [stateContratoSituacao, setStateContratoSituacao] = useState<{ nome: string, id: number } | null>(null);

    const [valorRadioButtomUsuarioRapido, setValorRadioButtomUsuarioRapido] = useState<'SemContrato' | 'ComContrato'>('ComContrato');
    const refvalorRadioButtomUsuarioRapido = React.useRef<'SemContrato' | 'ComContrato'>('ComContrato');

    const [cidadesDoContratoInSelect, setCidadesDoContratoInSelect] = useState<
        {
            clickOpenSelect: boolean, cidades: Array<intfaDadosCidadesDoContrato>
        }
    >(
        {
            cidades: [],
            clickOpenSelect: true
        }
    );

    const [valueEnviarContatoWhats, setValueEnviarContatoWhats] = useState(true);
    const [msgUsuarioJaExiste, setMsgUsuarioJaExiste] = useState(false);

    const [isSelectContratoOpen, setIsSelectContratoOpen] = useState(false);

    //Select Contrato paginate
    const [dataListContrato, setDataListContrato] = useState<IContratoLsStorage[]>([]);
    const [dadosListContratoSelecionado, setDadosListContratoSelecionado] = useState<
        {
            clickOpenSelect: boolean,
            contratos: IContratoLsStorage[]
        }
    >(
        {
            clickOpenSelect: true,
            contratos: []
        }
    );

    const [loadingContrato, setLoadingContrato] = useState(false);
    const [paginaAtualSelectContrato, setPaginaAtualSelectContrato] = useState(1);
    const [temMaisSelectContrato, setTemMaisSelectContrato] = useState(true);
    const [buscaSelectContrato, setBuscaSelectContrato] = useState('');

    //Select Contrato paginate
    const [dataListCidades, setDataListCidades] = useState<DadosCidadesAll[]>([]);
    const [loadingCidades, setLoadingCidades] = useState(false);
    const [paginaAtualSelectCidades, setPaginaAtualSelectCidades] = useState(1);
    const [temMaisSelectCidades, setTemMaisSelectCidades] = useState(true);
    const [buscaSelectCidades, setBuscaSelectCidades] = useState('');
    // const [, setValorLsStorageContratoSelecionado] = useState<>(null);


    //executa apenas ao iniciar o component
    useEffect(() => {

        let dadosLocalStorage: string | null = localStorage.getItem('@GovFacil:ListUsersContrato');
        let localUserData: any = null;
        if (typeof dadosLocalStorage == 'string') {
            localUserData = JSON.parse(dadosLocalStorage);
        }
        if (localUserData) {
            valorLsStorageContratoSelecionado.current = localUserData
        }

        // buscaDadosContratosAndSetSelectedUserRapido();

        // Data do prox contato default is true então iniciar com 15dias
        let dataEHoraSomada = format(
            addDays(
                new Date(),
                30
            )
            , 'yyyy-MM-dd HH:mm'
        )

        setTimeout(() => {
            setSelectedDateVincularUserRapido(moment(dataEHoraSomada))
        }, 500);

    }, []);

    //executa apenas quando desmonta o component
    const comonentExecutaAoDestroy = useEffect(() => () => {
        signal.cancel("Requisicao cancelada!")
        signal1.cancel("Requisicao cancelada!")
    }, []);

    const encontrarCargoPorId = useCallback((id): any => {

        const recebeFilter = refDadosCargoList.current.filter((element, index) => (
            element.id === id
        ))

        return recebeFilter[0]

    }, []);

    const encontrarPoderPorId = useCallback((id): any => {

        const recebeFilter = refDadosPoderList.current.filter((element, index) => (
            element.id === id
        ))

        return recebeFilter[0]

    }, []);

    const encontrarPoderPorNomeESetarCampo = useCallback((nome): void => {

        const recebeFilter = refDadosPoderList.current.filter((element, index) => (
            element.nome === nome
        ))

        refFormModalUserRapido.current?.setFieldsValue({
            poder_id: recebeFilter[0]?.id,
        });

    }, []);

    const encontrarContratoPorId = useCallback((id) => {

        const recebeFilter = refAllDadosContrato.current.filter((element, index) => (
            element.id === id
        ))

        encontrarPoderPorNomeESetarCampo(recebeFilter[0]?.poder?.nome)

        setStateContratoSituacao(recebeFilter[0]?.tipo_contrato)

        return recebeFilter

    }, []);

    const buscaDadosCidadesPorContrato = useCallback((id: string | number): void => {

        const buscaDeDadosContratos = async () => {
            try {

                setLoadingSelCity(true)

                let result = await axios.get(urlCidadesContrato + '/' + id,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setCidadesDoContratoInSelect({
                    cidades: result.data,
                    clickOpenSelect: false
                });

                if (result.data.length === 1) {

                    refFormModalUserRapido.current?.setFieldsValue({
                        cidade_id: result.data[0].id,
                    });
                } else {
                    refFormModalUserRapido.current?.setFieldsValue({
                        cidade_id: undefined,
                    });
                }


                setLoadingSelCity(false)


            } catch (error) {

                setLoadingSelCity(false)

                let msgErro: any = (error as Error);

                if (msgErro?.message != 'Requisicao cancelada!') {

                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosContratos();

    }, []);

    const onChangeUsuarioRapido = useCallback((val): void => {

        setValorRadioButtomUsuarioRapido(val.target.value)
        refvalorRadioButtomUsuarioRapido.current = val.target.value

        if (!valorLsStorageContratoSelecionado.current) {
            if (val.target.value === 'ComContrato') {
                refFormModalUserRapido.current?.setFieldsValue({
                    cidade_id: undefined,
                    contrato_id: undefined,
                    plano_id: undefined,
                });
            }
            if (val.target.value === 'SemContrato') {
                const posicaoDiamante = refDadosPlanoList.current.findIndex((plano) => plano.nome === 'Diamante')

                refFormModalUserRapido.current?.setFieldsValue({
                    cidade_id: undefined,
                    contrato_id: undefined,
                    plano_id: refDadosPlanoList.current[posicaoDiamante]?.id,
                });
            }
        }

    }, []);

    const onChangeSelectContratos = useCallback((value, obj): void => {

        const contrato = encontrarContratoPorId(value)

        if (contrato[0]?.validade_teste) {
            // se tiver validade de teste setar ela como prox contato
            let dataEHoraSomada = format(
                new Date(contrato[0]?.validade_teste)
                , 'yyyy-MM-dd HH:mm'
            )

            setTimeout(() => {
                handleDateChange(moment(dataEHoraSomada))
            }, 500);
        } else {
            //se nao setar 15 dias default

            let dataEHoraSomada = format(
                addDays(
                    new Date(),
                    30
                )
                , 'yyyy-MM-dd HH:mm'
            )

            setTimeout(() => {
                handleDateChange(moment(dataEHoraSomada))
            }, 500);
        }

        if (contrato[0]?.plano?.id) {
            refFormModalUserRapido.current?.setFieldsValue({
                plano_id: contrato[0]?.plano?.id,
            });
        }

        // refIDContrato.current = value;
        // refNomeContrato.current = obj?.children;

        buscaDadosCidadesPorContrato(value);

    }, []);

    const buscarDadosPlanoList = useCallback((setValue?: string) => {

        setLoadingPlanoSelected(true);
        const requestAsync = async () => {
            try {
                let result = await axios.get(urlContratosPlano,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                refDadosPlanoList.current = result.data;
                setDadosPlanoList(result.data)

                setLoadingPlanoSelected(false);
            } catch (error) {
                let msgErro: any = (error as Error);

                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingPlanoSelected(false);
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        requestAsync();

    }, []);

    //funcoes user rapido
    //para setar no campo parametro um e dois, se for setar no campo pelo id param 3 e 4
    const buscarDadosPoderList = useCallback(() => {

        setLoadingPoderSelected(true);
        const buscaDadosPoder = async () => {
            try {
                let result = await axios.get(urlPoder,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });
                setDadosPoderList(result.data);
                refDadosPoderList.current = result.data

                setLoadingPoderSelected(false);
            } catch (error) {
                let msgErro: any = (error as Error);

                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingPoderSelected(false);
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDadosPoder();

    }, []);

    const buscarDadosCargosList = useCallback(() => {

        const buscaDadosCargo = async () => {
            try {
                let result = await axios.get(urlCargo,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });

                setDadosDoCargoList(result.data)
                refDadosCargoList.current = result.data

            } catch (error) {
                console.error(error);
            }
        }

        buscaDadosCargo();

    }, []);

    const buscarDadosAoAbrirModalUserRapido = useCallback(() => {

        const buscaDadosEAvririModal = async () => {
            try {
                refFormModalUserRapido.current?.resetFields();

                setModalAddUserRapido(true);
                setLoadingFormAddUserRapido(true)

                buscarDadosPlanoList()
                buscarDadosPoderList()

                buscarDadosCargosList();

                let dataSomada = format(
                    addDays(
                        new Date(),
                        30
                    )
                    , 'yyyy-MM-dd'
                )

                let dataSomadaHora = format(
                    addDays(
                        new Date(),
                        30
                    )
                    , 'yyyy-MM-dd HH:mm'
                )
                // let dataSomada = addDays(
                //     new Date(),
                //     7
                // )

                // if (dadosCidadesList.length > 0) {

                // } else {

                //     buscarDadosCidadesList();
                // }


                setTimeout(() => {

                    // refFormModalUserRapido.current?.setFieldsValue({
                    //     validade_teste: moment(dataSomada),
                    // });


                    handleDateChange(moment(dataSomada))

                    if (valorLsStorageContratoSelecionado.current) {

                        setDadosListContratoSelecionado({
                            contratos: [valorLsStorageContratoSelecionado.current],
                            clickOpenSelect: false
                        })

                        refFormModalUserRapido.current?.setFieldsValue({
                            contrato_id: valorLsStorageContratoSelecionado.current?.id,
                        });

                        // const contraoCompleto = encontrarContratoPorId(valorLsStorageContratoSelecionado.current?.id)

                        buscaDadosCidadesPorContrato(valorLsStorageContratoSelecionado.current?.id);


                        if (valorLsStorageContratoSelecionado.current?.plano?.id) {
                            refFormModalUserRapido.current?.setFieldsValue({
                                plano_id: valorLsStorageContratoSelecionado.current?.plano?.id,
                            });
                        }
                    }
                    // inputNomeCompletoUserRapido.current?.focus();

                    setLoadingFormAddUserRapido(false);
                }, 500);



            } catch (error) {
                setLoadingFormAddUserRapido(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message != 'Requisicao cancelada!') {
                    // setLoadingSelectedCidades(false);
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDadosEAvririModal();

    }, [dadosCidadesList]);

    useEffect(() => {
        const buscaDeDados = async () => {
            try {

                if (visible) {
                    setLoadingFormAddUserRapido(true)
                    // await buscaDadosContratosAndSetSelectedUserRapido();
                    setTimeout(() => {
                        buscarDadosAoAbrirModalUserRapido();
                    }, 500);
                }
            } catch (error) {

                let msgErro: any = (error as Error);

                if (msgErro?.message != 'Requisicao cancelada!') {

                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDados();

    }, [visible]);

    const buscarCelularSeJaExiste = useCallback((celular: string): Promise<boolean> => {
        const digits = apenasDigitosCelular(celular);
        if (digits.length !== CELULAR_DIGITOS_BR) {
            return Promise.resolve(false);
        }

        const buscaDadosTipoDeContrato = async (): Promise<boolean> => {
            try {
                let result = await axios.get(urlBuscaUserByCelular + digits,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });
                if (typeof result.data == 'string') {
                    setMsgUsuarioJaExiste(false)

                    if (!refClickSubmitSalvar.current) {
                        refFormModalUserRapido.current?.setFieldsValue({
                            nome: '',
                        });
                    }

                    return false;
                } else {

                    if (!refClickSubmitSalvar.current) {
                        refFormModalUserRapido.current?.setFieldsValue({
                            nome: result.data.nome,
                            cargo_id: result.data.cargo.id,
                        });
                    }

                    if (refvalorRadioButtomUsuarioRapido.current === 'ComContrato') {
                        setMsgUsuarioJaExiste(false)
                        return true;
                    } else {
                        setMsgUsuarioJaExiste(true)
                        return false;
                    }
                }
            } catch (error) {
                notification.error({
                    message: 'Erro',
                    description:
                        'Não foi possivel consultar celular!',
                });
                return false
            }
        }

        return buscaDadosTipoDeContrato();

    }, []);


    const onChangeEnviarWhatsApp = useCallback((e): void => {
        setValueEnviarContatoWhats(e.target.value)
    }, []);


    const onChangeInputTelefone = useCallback((e: any) => {
        const originalValue = apenasDigitosCelular(e.target.value);
        const maskedValue = mask(originalValue, [
            // "(99) 9999-9999",
            "(99) 9 9999-9999"
        ]);

        refFormModalUserRapido.current.setFieldsValue(
            { celular: maskedValue }
        );
        if (originalValue.length === CELULAR_DIGITOS_BR) {
            refFormModalUserRapido.current.validateFields(["celular"])
        }

    }, []);

    const onChangeSwitchIsVisibleDateProximoContato = useCallback((checked): void => {
        let dataEHoraSomada = format(
            addDays(
                new Date(),
                30
            )
            , 'yyyy-MM-dd HH:mm'
        )

        if (checked) {

            setTimeout(() => {
                setSelectedDateVincularUserRapido(moment(dataEHoraSomada))
            }, 500);
        } else {
            setSelectedDateVincularUserRapido(null)
        }

        setIsVisibleDateProximoContato(checked)
    }, []);

    const clickCancelModalUserRapido = useCallback((): void => {
        refClickSubmitSalvar.current = false;
        setModalAddUserRapido(false);
        setFecharModal();
    }, []);

    const clickSubmitModalAddUserRapido = useCallback((): void => {

        refClickSubmitSalvar.current = true

        const salvarDadosModal = async (values: any) => {
            try {
                setLoadingFormAddUserRapido(true);

                if (valorRadioButtomUsuarioRapido === 'ComContrato') {

                    await axios.post(urlUsersAutomaticoAtendimento, values,
                        { headers: { 'Authorization': 'Bearer ' + getToken() } });

                } else {

                    await axios.post(urlUserContratoAutomatico, values,
                        { headers: { 'Authorization': 'Bearer ' + getToken() } });

                }

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Seus dados foram atualizados com sucesso!',
                });

                setLoadingFormAddUserRapido(false);

                // buscaDadosUsuariosAtivosAndSetTable();
                // mensagemDeAtencaoNaTelaPeloCache(true);

                clickCancelModalUserRapido();
                refFormModalUserRapido.current?.resetFields();
            } catch (error) {
                let msgErro: any = (error as Error);
                refClickSubmitSalvar.current = false;
                setLoadingFormAddUserRapido(false);
                notification.error({
                    message: 'Erro',
                    description:
                        msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel salvar, entre em contato com suporte!',
                });
            }
        }

        // Com contrato é uma rota sem contrato é outra rota,
        // com contrato é a rota de atendimentos, e sem contrato é a rota que ja esta usuario rapido

        refFormModalUserRapido.current?.validateFields()
            .then((values: any) => {

                values = {
                    ...values,
                    celular: apenasDigitosCelular(values.celular),
                    // validade_teste: values?.validade_teste ? convertDataBrParaUS(values.validade_teste) : undefined,
                    validade_teste: selectedDate ? convertDataBrParaUS(selectedDate) : undefined,
                    data_proximo_contato: selectedDateVincularUserRapido && selectedDateVincularUserRapido != '' ?
                        convertDataEHoraBrParaUS(selectedDateVincularUserRapido)
                        : undefined,
                }

                const nomePoder = encontrarPoderPorId(values.poder_id)?.nome
                const nomeCargo = encontrarCargoPorId(values.cargo_id)?.nome
                if (
                    nomePoder &&
                    nomePoder === 'Executivo'
                ) {
                    if (nomeCargo &&
                        nomeCargo === 'Vereador(a)') {
                        Modal.confirm({
                            className: 'modalContratoAtivoInativo',
                            title: 'Cuidado',
                            icon: <ExclamationCircleOutlined />,
                            content: 'O usuário cadastrado é Vereador no contrato de poder Executivo! Tem certeza que deseja continuar?',
                            okText: 'Sim',
                            okType: 'danger',
                            cancelText: 'Rever campos',
                            onOk() {
                                salvarDadosModal(values);
                            },
                            onCancel() {
                                refClickSubmitSalvar.current = false;
                            },
                        });
                        return false
                    }
                    if (nomeCargo &&
                        nomeCargo === 'Presidente da Câmara') {
                        Modal.confirm({
                            className: 'modalContratoAtivoInativo',
                            title: 'Cuidado',
                            icon: <ExclamationCircleOutlined />,
                            content: 'O usuário cadastrado é Presidente da Câmara no contrato de poder Executivo! Tem certeza que deseja continuar?',
                            okText: 'Sim',
                            okType: 'danger',
                            cancelText: 'Rever campos',
                            onOk() {
                                salvarDadosModal(values);
                            },
                            onCancel() {
                                refClickSubmitSalvar.current = false;
                            },
                        });
                        return false
                    }

                }

                if (
                    nomePoder &&
                    nomePoder === 'Legislativo'
                ) {
                    if (nomeCargo &&
                        nomeCargo === 'Prefeito(a)') {
                        Modal.confirm({
                            className: 'modalContratoAtivoInativo',
                            title: 'Cuidado',
                            icon: <ExclamationCircleOutlined />,
                            content: 'O usuário cadastrado é Prefeito(a) no contrato de poder Legislativo! Tem certeza que deseja continuar?',
                            okText: 'Sim',
                            okType: 'danger',
                            cancelText: 'Rever campos',
                            onOk() {
                                salvarDadosModal(values);
                            },
                            onCancel() {
                                refClickSubmitSalvar.current = false;
                            },
                        });
                        return false

                    }
                    if (nomeCargo &&
                        nomeCargo === 'Ex-Prefeito(a)') {
                        Modal.confirm({
                            className: 'modalContratoAtivoInativo',
                            title: 'Cuidado',
                            icon: <ExclamationCircleOutlined />,
                            content: 'O usuário cadastrado é Ex-Prefeito(a) no contrato de poder Legislativo! Tem certeza que deseja continuar?',
                            okText: 'Sim',
                            okType: 'danger',
                            cancelText: 'Rever campos',
                            onOk() {
                                salvarDadosModal(values);
                            },
                            onCancel() {
                                refClickSubmitSalvar.current = false;
                            },
                        });
                        return false
                    }
                    if (nomeCargo &&
                        nomeCargo === 'Vice Prefeito(a)') {
                        Modal.confirm({
                            className: 'modalContratoAtivoInativo',
                            title: 'Cuidado',
                            icon: <ExclamationCircleOutlined />,
                            content: 'O usuário cadastrado é Vice Prefeito(a) no contrato de poder Legislativo! Tem certeza que deseja continuar?',
                            okText: 'Sim',
                            okType: 'danger',
                            cancelText: 'Rever campos',
                            onOk() {
                                salvarDadosModal(values);
                            },
                            onCancel() {
                                refClickSubmitSalvar.current = false;
                            },
                        });
                        return false
                    }
                }

                salvarDadosModal(values);

            })
            .catch((errorInfo: any) => {
                refClickSubmitSalvar.current = false;
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });
    }, [selectedDate, selectedDateVincularUserRapido, valorRadioButtomUsuarioRapido]);


    const fetchCidades = async (pagina = 1, nome = '') => {
        if (!temMaisSelectCidades && pagina !== 1) return;

        try {
            setLoadingCidades(true);
            const { data } = await axios.get(`${urlBuscaCidadesSimples}?pagina=${pagina}&limit=10&nome=${nome}`, {
                headers: { Authorization: 'Bearer ' + getToken() },
            });

            if (pagina === 1) {
                setDataListCidades(data);
            } else {
                setDataListCidades(prev => [...prev, ...data]);
            }

            setTemMaisSelectCidades(data.length === 10);
            setPaginaAtualSelectCidades(pagina);
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível buscar cidades!',
            });
        } finally {
            setLoadingCidades(false);
        }
    };

    const fetchContratos = async (pagina = 1, nome = '') => {
        if (!temMaisSelectContrato && pagina !== 1) return;

        try {
            setLoadingContrato(true);
            const { data } = await axios.get(`${urlContratoSimplesAtivos}?pagina=${pagina}&limit=10&nome=${nome}`, {
                headers: { Authorization: 'Bearer ' + getToken() },
            });
            refAllDadosContrato.current = data

            if (pagina === 1) {
                setDataListContrato(data);
            } else {
                setDataListContrato(prev => [...prev, ...data]);
            }

            setTemMaisSelectContrato(data.length === 10);
            setPaginaAtualSelectContrato(pagina);
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível buscar os contratos!',
            });
        } finally {
            setLoadingContrato(false);
        }
    };

    useEffect(() => {
        fetchCidades(1, '');
        fetchContratos(1, '');
    }, []);


    const onDropdownVisibleChangeContratos = (open: boolean) => {

        // corrige bug de select fechar sozinho quando clica
        if (refApertouSelectContrato.current !== 1) {
            setIsSelectContratoOpen(open)
        }

        if (open) {
            fetchContratos(1, '');
            setTemMaisSelectContrato(true)
            setPaginaAtualSelectContrato(1)
            setBuscaSelectContrato('')

            setDadosListContratoSelecionado(valor => {
                return {
                    contratos: valor.contratos,
                    clickOpenSelect: true
                }
            });

            if (refApertouSelectContrato.current === 0) {
                refFormModalUserRapido.current?.setFieldsValue({
                    contrato_id: undefined,
                });
            }

        }

        refApertouSelectContrato.current++
    }

    const handleSearchContratos = (value: string) => {
        setBuscaSelectContrato(value);
        fetchContratos(1, value);
    };

    const handleScrollContratos = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollTop + clientHeight >= scrollHeight - 5 && !loadingContrato) {
            fetchContratos(paginaAtualSelectContrato + 1, buscaSelectContrato);
        }
    };

    const onDropdownVisibleChangeCidades = (open: boolean) => {

        // corrige bug de select fechar sozinho quando clica
        if (refApertouSelectCidade.current !== 1) {
            setIsSelectCidadeOpen(open)
        }

        if (open) {
            fetchCidades(1, '');
            setTemMaisSelectCidades(true)
            setPaginaAtualSelectCidades(1)
            setBuscaSelectCidades('')

            setCidadesDoContratoInSelect(valor => {
                return {
                    cidades: valor.cidades,
                    clickOpenSelect: true
                }
            });

            if (refApertouSelectCidade.current === 0) {
                refFormModalUserRapido.current?.setFieldsValue({
                    cidade_id: undefined,
                });
            }
        }


        refApertouSelectCidade.current++

    }

    const handleSearchCidades = (value: string) => {
        setBuscaSelectCidades(value);
        fetchCidades(1, value);
    };

    const handleScrollCidades = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollTop + clientHeight >= scrollHeight - 5 && !loadingCidades) {
            fetchCidades(paginaAtualSelectCidades + 1, buscaSelectCidades);
        }
    };

    return (
        <>
            <Modal
                title="Adicionar Usuário Rápido"
                open={modalAddUserRapido}
                destroyOnClose
                className="modalAddAtendimentos"
                onOk={clickSubmitModalAddUserRapido}
                onCancel={clickCancelModalUserRapido}
                footer={[
                    <Button key="back" disabled={loadingFormAddUserRapido} onClick={clickCancelModalUserRapido}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={loadingFormAddUserRapido} onClick={clickSubmitModalAddUserRapido}>
                        Salvar
                    </Button>,
                ]}
            >
                <Spin spinning={loadingFormAddUserRapido}>
                    <Form
                        ref={refFormModalUserRapido}
                        name="formModalAddContato"
                        layout="vertical"
                        initialValues={{
                            remember: true,
                        }}
                        onFinishFailed={() => { }}
                    >
                        <Row>
                            <Col span={24} hidden={listagemPorContrato}>
                                <Radio.Group
                                    style={{
                                        marginBottom: 10,
                                        marginLeft: 5,
                                        marginRight: 5,
                                    }}
                                    buttonStyle="solid"
                                    onChange={onChangeUsuarioRapido}
                                    value={valorRadioButtomUsuarioRapido}
                                    disabled={listagemPorContrato}
                                >
                                    <Radio.Button value={'ComContrato'}>Com contrato</Radio.Button>
                                    <Radio.Button value={'SemContrato'}>Sem contrato</Radio.Button>
                                </Radio.Group>
                            </Col>
                            <Col
                                span={24}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                }}
                                hidden={!listagemPorContrato}
                            >
                                <div

                                    style={{
                                        marginRight: 5,
                                        marginLeft: 5,
                                        marginBottom: 15,
                                        borderColor: '#2D9CDB',
                                        borderStyle: 'solid',
                                        borderRadius: 4,
                                        borderWidth: 2,
                                        padding: 5,
                                    }}
                                >

                                    <Text
                                        strong
                                        style={{
                                            color: propsState.theme === 'light' ? '#1c73a5' : '#2D9CDB'
                                        }}
                                    >Com contrato</Text>
                                </div>

                            </Col>

                            {
                                msgUsuarioJaExiste && (
                                    <Col span={24}>
                                        <Text style={{ color: 'red', marginLeft: 5 }}>Usuário já existe!</Text><br />
                                        <Text style={{ color: 'red', marginLeft: 5 }}>Confirme os dados para atualizá-lo.</Text>
                                        <Divider style={{ margin: 0, padding: 0 }} />
                                    </Col>
                                )
                            }

                            {
                                valorRadioButtomUsuarioRapido === 'ComContrato' ?
                                    <>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Preencha o telefone!",
                                                        max: 16
                                                    },
                                                    () => ({
                                                        validator(rule, value) {
                                                            return new Promise((resolve: (value?: any) => void, reject) => {
                                                                //CUIDADO AO EDITAR PARA PODER ACEITAR MESMO EMAIL
                                                                if (value != '' && value != null) {
                                                                    const digits = apenasDigitosCelular(value);
                                                                    if (digits.length === CELULAR_DIGITOS_BR) {
                                                                        buscarCelularSeJaExiste(digits).then(valorPromessa => {
                                                                            if (valorPromessa) {
                                                                                reject("Celular já existe!");
                                                                            } else {
                                                                                resolve();
                                                                            }
                                                                        }).catch(error => {
                                                                            resolve();
                                                                        })
                                                                    } else {
                                                                        reject("Celular inválido");
                                                                    }
                                                                } else {
                                                                    reject('');
                                                                }
                                                            });
                                                        },
                                                    }),
                                                ]}
                                                name="celular"
                                                label="Telefone"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    type="tel"
                                                    autoComplete="off"
                                                    onChange={(e) => onChangeInputTelefone(e)}
                                                    placeholder="(44) 9 9999-9999"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Preencha o nome.",
                                                    },
                                                    () => ({
                                                        validator(rule, value) {
                                                            return new Promise((resolve: (value?: any) => void, reject) => {
                                                                //CUIDADO AO EDITAR PARA PODER ACEITAR MESMO EMAIL
                                                                if (value?.trim() != '' && value != null) {
                                                                    resolve('');
                                                                } else {
                                                                    reject('Preencha o nome!');
                                                                }
                                                            });
                                                        },
                                                    }),
                                                ]}
                                                name="nome"
                                                label="Nome Completo"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    ref={inputNomeCompletoUserRapido}
                                                    autoComplete="off"
                                                    readOnly={msgUsuarioJaExiste}
                                                    disabled={msgUsuarioJaExiste}
                                                    // onChange={onChangeInputNumberNumero}
                                                    placeholder="Nome"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="contrato_id"
                                                label="Contrato"
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione o contrato!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Selecione um Contrato"
                                                    onChange={onChangeSelectContratos}
                                                    onSearch={handleSearchContratos}
                                                    onPopupScroll={handleScrollContratos}
                                                    onDropdownVisibleChange={onDropdownVisibleChangeContratos}
                                                    loading={loadingContrato}
                                                    filterOption={false} // usamos busca no backend
                                                    style={{ width: '100%', marginBottom: 5, marginRight: 5 }}
                                                    open={isSelectContratoOpen}
                                                >
                                                    {dataListContrato.map(item => (
                                                        <Select.Option key={item.id} value={item.id}>
                                                            {item?.poder?.nome ? `${item.nome} - ${item.poder.nome}` : item.nome}
                                                        </Select.Option>
                                                    ))}
                                                    {
                                                        !dadosListContratoSelecionado.clickOpenSelect ?
                                                            dadosListContratoSelecionado.contratos.map((item) => {
                                                                return (
                                                                    <Select.Option
                                                                        value={item.id}
                                                                        key={item.id}
                                                                    >
                                                                        {item?.poder?.nome ? `${item.nome} - ${item.poder.nome}` : item.nome}
                                                                    </Select.Option>
                                                                )
                                                            })
                                                            :
                                                            <></>
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="cidade_id"
                                                label="Cidade"
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione a cidade!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    loading={loadingSelCity}
                                                    notFoundContent={loadingSelCity ? <Spin size="small" /> : null}
                                                    optionFilterProp="children"
                                                    onSelect={(id: any, obj: any) => {

                                                        refNomeCidadeModalUserRapido.current = obj?.children

                                                    }}
                                                    placeholder="Selecione..."
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }
                                                    }
                                                >
                                                    {
                                                        cidadesDoContratoInSelect.cidades.map((item) => {
                                                            return (
                                                                <Select.Option
                                                                    value={item.id}
                                                                    key={item.id}
                                                                >
                                                                    {item.nome + ' - ' + item?.uf}
                                                                </Select.Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="plano_id"
                                                label="Selecione o Plano"
                                                // initialValue={2}
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione o plano.',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    loading={loadingPlanoSelected}
                                                    notFoundContent={loadingPlanoSelected ? <Spin size="small" /> : null}
                                                    optionFilterProp="children"
                                                    placeholder="Selecione..."
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }}
                                                // onChange={(value) => { setValuePlano(value) }}
                                                // onSelect={(id: any, obj: any) => {

                                                //     refIdPoderModalUserRapido.current = id

                                                // }}
                                                >
                                                    {
                                                        dadosPlanoList.map((item) => {
                                                            return (

                                                                <Select.Option
                                                                    value={item.id}
                                                                    key={item.id}
                                                                >

                                                                    {item.nome}

                                                                </Select.Option>

                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="poder_id"
                                                label="Poder"
                                                initialValue={2}
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione o poder!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    disabled
                                                    loading={loadingPoderSelected}
                                                    notFoundContent={loadingPoderSelected ? <Spin size="small" /> : null}
                                                    optionFilterProp="children"
                                                    onSelect={(id: any, obj: any) => {

                                                        refIdPoderModalUserRapido.current = id

                                                    }}
                                                    placeholder="Selecione..."
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }}
                                                >
                                                    {dadosPoderList.map((item) => {
                                                        return (
                                                            <Select.Option
                                                                value={item.id}
                                                                key={item.id}
                                                            >
                                                                {item.nome}
                                                            </Select.Option>
                                                        )
                                                    })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="cargo_id"
                                                label="Cargo"
                                                initialValue={28}
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione o cargo!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    optionFilterProp="children"
                                                    placeholder="Selecione..."
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }}
                                                >
                                                    {
                                                        dadosDoCargoList.map((item) => {
                                                            return (
                                                                <Select.Option
                                                                    value={item.id}
                                                                    key={item.id}
                                                                >
                                                                    {item.nome}
                                                                </Select.Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col
                                            hidden={
                                                stateContratoSituacao?.nome === 'Período de Teste' ||
                                                    stateContratoSituacao?.nome === 'Automático' ?
                                                    false : true
                                            }
                                            {...modalAddModuloInputs}
                                        >
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Preencha o data!",
                                                    },
                                                    // () => ({
                                                    //     validator(rule, value) {
                                                    //         if (value != '' && value != null) {
                                                    //             if (value.length < 10) {
                                                    //                 return Promise.reject('Data Inválida');
                                                    //             } else {
                                                    //                 if (moment(value, 'DD/MM/YYYY HH:mm', true).isValid()) {
                                                    //                     return Promise.resolve();
                                                    //                 } else {
                                                    //                     return Promise.reject('Data Inválida');
                                                    //                 }
                                                    //             }

                                                    //         } else {
                                                    //             return Promise.resolve();
                                                    //         }
                                                    //     },
                                                    // }),
                                                ]}
                                                name="validade_teste"
                                                // label="Próximo contato"
                                                label="Validade do Teste"
                                                style={{ margin: 5 }}

                                            >
                                                <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils} >
                                                    <DatePicker
                                                        value={selectedDate}
                                                        onChange={handleDateChange}
                                                        required={false}
                                                        format="dd/MM/yyyy"
                                                        className="datePickerCOlors"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        // required: true,
                                                        // message: "Preencha o status!",
                                                    }
                                                ]}
                                                name="isdateproximocontato"
                                                label="Deseja alterar a data do Próximo Contato?"
                                                style={{ margin: 5 }}
                                            >
                                                <>
                                                    <Switch
                                                        checkedChildren="Sim"
                                                        unCheckedChildren="Não"
                                                        checked={isVisibleDateProximoContato}
                                                        onChange={onChangeSwitchIsVisibleDateProximoContato}
                                                    />
                                                </>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                initialValue={true}
                                                name="enviar_whatsapp"
                                                label="Enviar WhatsApp Cadastro"
                                                style={{ margin: 5 }}
                                            >
                                                <Radio.Group onChange={onChangeEnviarWhatsApp}>
                                                    <Radio.Button value={true}>Sim</Radio.Button>
                                                    <Radio.Button value={false}>Não</Radio.Button>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        {
                                            valueEnviarContatoWhats && (
                                                <Col {...modalAddModuloInputs}>
                                                    <Form.Item
                                                        initialValue={true}
                                                        name="enviar_contato_vendedor"
                                                        label="Enviar Contato Vendedor"
                                                        style={{ margin: 5 }}
                                                        rules={[
                                                        ]}
                                                    >
                                                        <Radio.Group>
                                                            <Radio.Button value={true}>Sim</Radio.Button>
                                                            <Radio.Button value={false}>Não</Radio.Button>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>
                                            )
                                        }

                                        <Col hidden={!isVisibleDateProximoContato} {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Preencha o data!",
                                                    },
                                                    // () => ({
                                                    //     validator(rule, value) {
                                                    //         if (value != '' && value != null) {
                                                    //             if (value.length < 10) {
                                                    //                 return Promise.reject('Data Inválida');
                                                    //             } else {
                                                    //                 if (moment(value, 'DD/MM/YYYY', true).isValid()) {
                                                    //                     return Promise.resolve();
                                                    //                 } else {
                                                    //                     return Promise.reject('Data Inválida');
                                                    //                 }
                                                    //             }

                                                    //         } else {
                                                    //             return Promise.resolve();
                                                    //         }
                                                    //     },
                                                    // }),
                                                ]}
                                                name="data_proximo_contato"
                                                label="Próx. Contato"
                                                style={{ margin: 5 }}
                                            >
                                                {/* <Input
                                            autoComplete="off"
                                            placeholder="31/12/2000"
                                            onChange={onChangeDataValidadeTeste}
                                        /> */}
                                                <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils} >
                                                    <DateTimePicker
                                                        value={selectedDateVincularUserRapido}
                                                        onChange={setSelectedDateVincularUserRapido}
                                                        required={false}
                                                        style={{
                                                            width: '100%'
                                                        }}
                                                        okLabel="Ok"
                                                        clearLabel="Limpar"
                                                        cancelLabel="Cancelar"
                                                        clearable
                                                        format="dd/MM/yyyy HH:mm"
                                                        className="datePickerCOlors"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Form.Item>
                                        </Col>
                                    </>
                                    :
                                    <>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Preencha o telefone!",
                                                        max: 16
                                                    },
                                                    () => ({
                                                        validator(rule, value) {
                                                            return new Promise((resolve: (value?: any) => void, reject) => {
                                                                //CUIDADO AO EDITAR PARA PODER ACEITAR MESMO EMAIL
                                                                if (value != '' && value != null) {
                                                                    const digits = apenasDigitosCelular(value);
                                                                    if (digits.length === CELULAR_DIGITOS_BR) {
                                                                        buscarCelularSeJaExiste(digits).then(valorPromessa => {
                                                                            if (valorPromessa) {
                                                                                reject("Celular já existe!");
                                                                            } else {
                                                                                resolve();
                                                                            }
                                                                        }).catch(error => {
                                                                            resolve();
                                                                        })
                                                                    } else {
                                                                        reject("Celular inválido");
                                                                    }
                                                                } else {
                                                                    reject('');
                                                                }
                                                            });
                                                        },
                                                    }),
                                                ]}
                                                name="celular"
                                                label="Telefone"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    type="tel"
                                                    autoComplete="off"
                                                    onChange={(e) => onChangeInputTelefone(e)}
                                                    placeholder="(44) 9 9999-9999"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Preencha o nome.",
                                                    },
                                                    () => ({
                                                        validator(rule, value) {
                                                            return new Promise((resolve: (value?: any) => void, reject) => {
                                                                //CUIDADO AO EDITAR PARA PODER ACEITAR MESMO EMAIL
                                                                if (value?.trim() != '' && value != null) {
                                                                    resolve('');
                                                                } else {
                                                                    reject('Preencha o nome!');
                                                                }
                                                            });
                                                        },
                                                    }),
                                                ]}
                                                name="nome"
                                                label="Nome Completo"
                                                style={{ margin: 5 }}
                                            >
                                                <Input
                                                    ref={inputNomeCompletoUserRapido}
                                                    autoComplete="off"
                                                    readOnly={msgUsuarioJaExiste}
                                                    disabled={msgUsuarioJaExiste}
                                                    // onChange={onChangeInputNumberNumero}
                                                    placeholder="Nome"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="cidade_id"
                                                label="Cidade"
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione a cidade!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Selecione uma Cidade"
                                                    onSearch={handleSearchCidades}
                                                    onPopupScroll={handleScrollCidades}
                                                    onDropdownVisibleChange={onDropdownVisibleChangeCidades}
                                                    loading={loadingCidades}
                                                    filterOption={false} // usamos busca no backend
                                                    style={{ width: '100%', marginBottom: 5, marginRight: 5 }}
                                                    open={isSelectCidadeOpen}
                                                >
                                                    {dataListCidades.map(item => (
                                                        <Select.Option key={item.id} value={item.id}>
                                                            {item.nome + ' - ' + item?.uf}
                                                        </Select.Option>
                                                    ))}
                                                    {
                                                        !cidadesDoContratoInSelect.clickOpenSelect ?
                                                            cidadesDoContratoInSelect.cidades.map((item) => {
                                                                return (
                                                                    <Select.Option
                                                                        value={item.id}
                                                                        key={item.id}
                                                                    >
                                                                        {item.nome + ' - ' + item?.uf}
                                                                    </Select.Option>
                                                                )
                                                            })
                                                            :
                                                            <></>
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="plano_id"
                                                label="Selecione o Plano"
                                                // initialValue={2}
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione o plano.',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    loading={loadingPlanoSelected}
                                                    notFoundContent={loadingPlanoSelected ? <Spin size="small" /> : null}
                                                    optionFilterProp="children"
                                                    placeholder="Selecione..."
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }}
                                                // onChange={(value) => { setValuePlano(value) }}
                                                // onSelect={(id: any, obj: any) => {

                                                //     refIdPoderModalUserRapido.current = id

                                                // }}
                                                >
                                                    {
                                                        dadosPlanoList.map((item) => {
                                                            return (

                                                                <Select.Option
                                                                    value={item.id}
                                                                    key={item.id}
                                                                >

                                                                    {item.nome}

                                                                </Select.Option>

                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="poder_id"
                                                label="Poder"
                                                initialValue={2}
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione o poder!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    loading={loadingPoderSelected}
                                                    notFoundContent={loadingPoderSelected ? <Spin size="small" /> : null}
                                                    optionFilterProp="children"
                                                    onSelect={(id: any, obj: any) => {

                                                        refIdPoderModalUserRapido.current = id

                                                    }}
                                                    placeholder="Selecione..."
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }}
                                                >
                                                    {dadosPoderList.map((item) => {
                                                        return (
                                                            <Select.Option
                                                                value={item.id}
                                                                key={item.id}
                                                            >
                                                                {item.nome}
                                                            </Select.Option>
                                                        )
                                                    })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                name="cargo_id"
                                                label="Cargo"
                                                initialValue={28}
                                                style={{ margin: 5 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Por favor selecione o cargo!',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    optionFilterProp="children"
                                                    placeholder="Selecione..."
                                                    filterOption={(input: any, option: any) => {
                                                        let textDigit = removeAcento(input)
                                                        let listCidade = removeAcento(option?.children);
                                                        return listCidade.indexOf(textDigit) >= 0
                                                    }}
                                                >
                                                    {
                                                        dadosDoCargoList.map((item) => {
                                                            return (
                                                                <Select.Option
                                                                    value={item.id}
                                                                    key={item.id}
                                                                >
                                                                    {item.nome}
                                                                </Select.Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Preencha o data!",
                                                    },
                                                    // () => ({
                                                    //     validator(rule, value) {
                                                    //         if (value != '' && value != null) {
                                                    //             if (value.length < 10) {
                                                    //                 return Promise.reject('Data Inválida');
                                                    //             } else {
                                                    //                 if (moment(value, 'DD/MM/YYYY HH:mm', true).isValid()) {
                                                    //                     return Promise.resolve();
                                                    //                 } else {
                                                    //                     return Promise.reject('Data Inválida');
                                                    //                 }
                                                    //             }

                                                    //         } else {
                                                    //             return Promise.resolve();
                                                    //         }
                                                    //     },
                                                    // }),
                                                ]}
                                                name="validade_teste"
                                                // label="Próximo contato"
                                                label="Validade do Teste"
                                                style={{ margin: 5 }}

                                            >
                                                <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils} >
                                                    <DatePicker
                                                        value={selectedDate}
                                                        onChange={handleDateChange}
                                                        required={false}
                                                        format="dd/MM/yyyy"
                                                        className="datePickerCOlors"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Form.Item>
                                        </Col>
                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        // required: true,
                                                        // message: "Preencha o status!",
                                                    }
                                                ]}
                                                name="isdateproximocontato"
                                                label="Deseja alterar a data do Próximo Contato?"
                                                style={{ margin: 5 }}
                                            >
                                                <>
                                                    <Switch
                                                        checkedChildren="Sim"
                                                        unCheckedChildren="Não"
                                                        checked={isVisibleDateProximoContato}
                                                        onChange={onChangeSwitchIsVisibleDateProximoContato}
                                                    />
                                                </>
                                            </Form.Item>
                                        </Col>

                                        <Col {...modalAddModuloInputs}>
                                            <Form.Item
                                                initialValue={true}
                                                name="enviar_whatsapp"
                                                label="Enviar WhatsApp Cadastro"
                                                style={{ margin: 5 }}
                                            >
                                                <Radio.Group onChange={onChangeEnviarWhatsApp}>
                                                    <Radio.Button value={true}>Sim</Radio.Button>
                                                    <Radio.Button value={false}>Não</Radio.Button>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        {
                                            valueEnviarContatoWhats && (
                                                <Col {...modalAddModuloInputs}>
                                                    <Form.Item
                                                        initialValue={true}
                                                        name="enviar_contato_vendedor"
                                                        label="Enviar Contato Vendedor"
                                                        style={{ margin: 5 }}
                                                        rules={[
                                                        ]}
                                                    >
                                                        <Radio.Group>
                                                            <Radio.Button value={true}>Sim</Radio.Button>
                                                            <Radio.Button value={false}>Não</Radio.Button>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>
                                            )
                                        }
                                        <Col hidden={!isVisibleDateProximoContato} {...modalAddModuloInputs}>
                                            <Form.Item
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Preencha o data!",
                                                    },
                                                    // () => ({
                                                    //     validator(rule, value) {
                                                    //         if (value != '' && value != null) {
                                                    //             if (value.length < 10) {
                                                    //                 return Promise.reject('Data Inválida');
                                                    //             } else {
                                                    //                 if (moment(value, 'DD/MM/YYYY', true).isValid()) {
                                                    //                     return Promise.resolve();
                                                    //                 } else {
                                                    //                     return Promise.reject('Data Inválida');
                                                    //                 }
                                                    //             }

                                                    //         } else {
                                                    //             return Promise.resolve();
                                                    //         }
                                                    //     },
                                                    // }),
                                                ]}
                                                name="data_proximo_contato"
                                                label="Próx. Contato"
                                                style={{ margin: 5 }}
                                            >
                                                {/* <Input
                                            autoComplete="off"
                                            placeholder="31/12/2000"
                                            onChange={onChangeDataValidadeTeste}
                                        /> */}
                                                <MuiPickersUtilsProvider locale={ptLocale} utils={DateFnsUtils} >
                                                    <DateTimePicker
                                                        value={selectedDateVincularUserRapido}
                                                        onChange={setSelectedDateVincularUserRapido}
                                                        required={false}
                                                        style={{
                                                            width: '100%'
                                                        }}
                                                        okLabel="Ok"
                                                        clearLabel="Limpar"
                                                        cancelLabel="Cancelar"
                                                        clearable
                                                        format="dd/MM/yyyy HH:mm"
                                                        className="datePickerCOlors"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Form.Item>
                                        </Col>
                                    </>
                            }
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
})

export default ModalUsuarioRapido;
